import axios from 'axios';

const API  = process.env.REACT_APP_API_URL || '';
const base = `${API}/api/sqf`;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// ─── Sensors ──────────────────────────────────────────────────────────────────
const getSensors     = ()             => axios.get(`${base}/temp-sensors`, auth()).then(r => r.data.sensors);
const getSensorChart = (id, period)   => axios.get(`${base}/temp-sensors/${id}/chart`, { ...auth(), params: { period } }).then(r => r.data);
const createSensor   = (data)     => axios.post(`${base}/temp-sensors`, data, auth()).then(r => r.data.sensor);
const updateSensor   = (id, data) => axios.put(`${base}/temp-sensors/${id}`, data, auth()).then(r => r.data.sensor);
const deleteSensor   = (id)       => axios.delete(`${base}/temp-sensors/${id}`, auth()).then(r => r.data);

// ─── Readings ─────────────────────────────────────────────────────────────────
const getReadings       = (params = {}) => axios.get(`${base}/temp-readings`, { ...auth(), params }).then(r => r.data);
const createReading     = (data)        => axios.post(`${base}/temp-readings`, data, auth()).then(r => r.data.reading);
const acknowledgeReading = (id, reason) => axios.put(`${base}/temp-readings/${id}/acknowledge`, { reason }, auth()).then(r => r.data.reading);

// ─── Provider Credentials ─────────────────────────────────────────────────────
const getCredentials          = ()               => axios.get(`${base}/temp-credentials`, auth()).then(r => r.data.credentials);
const saveCredentials         = (provider, data) => axios.put(`${base}/temp-credentials/${provider}`, data, auth()).then(r => r.data);
const saveCredentialSettings  = (provider, data) => axios.patch(`${base}/temp-credentials/${provider}/settings`, data, auth()).then(r => r.data);
const testCredentials         = (provider)       => axios.post(`${base}/temp-credentials/${provider}/test`, {}, auth()).then(r => r.data);
const syncNow                 = (provider)       => axios.post(`${base}/temp-credentials/${provider}/sync`, {}, auth()).then(r => r.data);
const backfill                = (provider)       => axios.post(`${base}/temp-credentials/${provider}/backfill`, {}, auth()).then(r => r.data);

const tempMonitoringService = {
  getSensors, createSensor, updateSensor, deleteSensor, getSensorChart,
  getReadings, createReading, acknowledgeReading,
  getCredentials, saveCredentials, saveCredentialSettings, testCredentials, syncNow, backfill,
};

export default tempMonitoringService;
